(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    /* The retail title must never line-break, however long the product
     name is — but it also has to stay as large as possible (it's the
     biggest element on the card). A single cqi-based font-size can't do
     both at once for every name length, so this measures each title's
     actual rendered width and shrinks font-size (in a loop, since text
     width doesn't scale linearly with font-size character-for-character)
     until it fits on one line inside its container. Runs on load and
     again once webfonts finish loading (metrics before that reflect the
     fallback font, not the real one), plus on resize. */
  function fitTitle(el) {
    const container = el.parentElement;
    if (!container) return;
    let fontSize = parseFloat(getComputedStyle(el).fontSize);
    const minFontSize = 14;
    el.style.fontSize = '';
    fontSize = parseFloat(getComputedStyle(el).fontSize);
    while (el.scrollWidth > container.clientWidth && fontSize > minFontSize) {
      fontSize -= 1;
      el.style.fontSize = fontSize + 'px';
    }
  }

  function fitAllTitles() {
    document.querySelectorAll('.product-card__title--back').forEach(fitTitle);
  }

  fitAllTitles();
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(fitAllTitles);
  }

  let titleResizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(titleResizeTimeout);
    titleResizeTimeout = setTimeout(fitAllTitles, 150);
  });

  /* Touch devices have no hover, so the back would otherwise be
     unreachable. First tap reveals it (like :hover); a second tap flips
     back to the front; only tapping the CTA itself follows the link. */
  document.querySelectorAll('[data-product-card]').forEach((card) => {
    card.addEventListener('click', (e) => {
      if (!window.matchMedia('(hover: none)').matches) return;

      if (card.classList.contains('is-flipped')) {
        if (e.target.closest('.product-card__cta--link')) return;
        e.preventDefault();
        card.classList.remove('is-flipped');
        return;
      }

      e.preventDefault();
      document.querySelectorAll('[data-product-card].is-flipped').forEach((other) => {
        if (other !== card) other.classList.remove('is-flipped');
      });
      card.classList.add('is-flipped');
    });
  });

  /* Wholesale reorder controls live inside the card's outer <a>. Every
     click here is stopped from bubbling so it neither navigates nor
     re-triggers the flip logic above — this block handles itself. */
  document.querySelectorAll('[data-wholesale-order]').forEach((order) => {
    /* stopPropagation alone only stops other JS listeners (like the card's
       own flip/navigate handler) from seeing this click — it does nothing
       to the browser's native "follow the <a href>" behavior. Since that
       outer handler is now skipped entirely, preventDefault has to happen
       here instead, and unconditionally (not just on touch), since on
       desktop nothing else was ever going to call it. */
    order.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
    });

    /* preventDefault above also swallows the browser's native "click this
       label → check its radio" behavior, since that's a default action tied
       to the same click event. With it blocked, the radio has to be checked
       by hand here, followed by a real 'change' event so the price-update
       listener below still fires the same way it would natively. */
    order.querySelectorAll('[data-size-pills] .product-card__size-pill').forEach((pillLabel) => {
      pillLabel.addEventListener('click', () => {
        const input = pillLabel.querySelector('input');
        if (input && !input.checked) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });

    /* Displayed price is unit price × quantity, recomputed on both a size
       change (different variant, different unit price) and a quantity
       change — previously only the size handler touched the price, so
       bumping quantity left the price stuck at the qty-1 amount. */
    const priceEl = order.querySelector('[data-order-price]');
    const qtyValue = order.querySelector('[data-quantity-value]');

    const formatMoney = (cents) => '$' + (cents / 100).toFixed(2);

    const updatePrice = () => {
      if (!priceEl) return;
      const checkedPill = order.querySelector('[data-size-pills] input:checked');
      const unitCents = parseInt(
        (checkedPill && checkedPill.dataset.priceCents) || order.dataset.defaultPriceCents,
        10
      ) || 0;
      const quantity = parseInt(qtyValue.textContent, 10) || 1;
      priceEl.textContent = formatMoney(unitCents * quantity);
    };

    order.querySelectorAll('[data-size-pills] input').forEach((pill) => {
      pill.addEventListener('change', updatePrice);
    });

    order.querySelectorAll('[data-quantity-adjust]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const current = parseInt(qtyValue.textContent, 10) || 1;
        const next = btn.dataset.quantityAdjust === 'plus' ? current + 1 : Math.max(1, current - 1);
        qtyValue.textContent = next;
        updatePrice();
      });
    });

    const addBtn = order.querySelector('[data-add-to-cart]');
    if (addBtn) {
      addBtn.addEventListener('click', () => {
        const checkedPill = order.querySelector('[data-size-pills] input:checked');
        const variantId = checkedPill ? checkedPill.value : order.dataset.defaultVariantId;
        if (!variantId) return;
        const quantity = parseInt(qtyValue.textContent, 10) || 1;

        addBtn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: quantity })
        })
          .then((res) => {
            if (!res.ok) throw new Error('add to cart failed');
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          })
          .catch(() => {
            if (window.showToast) window.showToast('Could not add to cart', 'error');
          })
          .finally(() => {
            addBtn.disabled = false;
          });
      });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
